var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dropzone",staticStyle:{"visibility":"hidden","opacity":"0"}},[_c('div',{staticClass:"dropzone-text"},[_vm._v(" Dateien hier ablegen ")])])
}]

export { render, staticRenderFns }